export const flatUniqConcat = (initial, ...others) => []
    .concat(...initial, ...others)
    .filter((elem, pos, arr) => arr.indexOf(elem) === pos);
